import api from './api';

/**
 * Service for On-Demand Healthcare event management
 */
class OnDemandEventService {
  /**
   * Fetch all events with optional filters
   */
  static async getEvents({ search, status, type, dateFrom, dateTo, staffingStatus } = {}) {
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    if (status) params.append('status', status);
    if (type) params.append('type', type);
    if (dateFrom) params.append('dateFrom', dateFrom);
    if (dateTo) params.append('dateTo', dateTo);
    if (staffingStatus) params.append('staffingStatus', staffingStatus);
    
    const query = params.toString();
    return api.get(`/ondemand/events${query ? `?${query}` : ''}`);
  }

  /**
   * Fetch a single event by ID
   */
  static async getEvent(id) {
    return api.get(`/ondemand/events/${id}`);
  }

  /**
   * Create a new event
   */
  static async createEvent(data) {
    return api.post('/ondemand/events', data);
  }

  /**
   * Update an existing event
   */
  static async updateEvent(id, data) {
    return api.put(`/ondemand/events/${id}`, data);
  }

  /**
   * Delete an event (only open events with no assignments)
   */
  static async deleteEvent(id) {
    return api.delete(`/ondemand/events/${id}`);
  }

  /**
   * Transition event status (lock, confirm, complete, cancel, reschedule)
   */
  static async transitionStatus(id, { status, reason }) {
    return api.put(`/ondemand/events/${id}/status`, { status, reason });
  }

  /**
   * Assign an HCW to an event
   */
  static async assignHCW(eventId, { hcwId, notes }) {
    return api.post(`/ondemand/events/${eventId}/assign-hcw`, { hcwId, notes });
  }

  /**
   * Remove an HCW assignment from an event
   */
  static async removeHCW(eventId, assignmentId) {
    return api.delete(`/ondemand/events/${eventId}/assign-hcw/${assignmentId}`);
  }

  /**
   * Designate a single assignment as the event's kit runner (storage pickup +
   * post-office drop-off). Pass assignmentId = null to clear the designation.
   */
  static async setKitRunner(eventId, assignmentId) {
    return api.put(`/ondemand/events/${eventId}/kit-runner`, { assignmentId });
  }

  /**
   * Manually promote a standby (waitlisted) assignment to a guaranteed spot.
   */
  static async promoteWaitlist(eventId, assignmentId) {
    return api.put(`/ondemand/events/${eventId}/assignments/${assignmentId}/promote`);
  }
}

export default OnDemandEventService;
